import React from 'react';
import './Spinner.scss';

const Spinner = () => {
  return <div className="Loader">Loading...</div>;
};

export default Spinner;
